import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from 'app/components/layout/Heading.styled';
import { Styled } from 'app/features/newLanding/components/HeroBlock/Perks/Perk.styled';
import Text from 'app/components/layout/Text.styled';

const OfflineViewing = () => (
  <Styled.Perk data-t="offline-viewing-perk">
    <Styled.PerkIcon viewBox="0 0 40 40" color="blue">
      <path d="M19.75 0C16.68.1 15 1.96 15 5.24V12L3 18.36v8.37l12-4.15v6.1l-4 5.7v4.56c0 .83.63 1.11 1.22 1.05.19-.01.38-.07.62-.16l.15-.05.34-.15.4-.18.46-.22.7-.35.76-.4.86-.46 1.3-.7 1.86-1.05.34-.2 2.3 1.25 1.66.88 1.1.57.48.24.7.34.4.19.32.14.15.06c.2.1.37.15.52.19.14.03.27.05.43.03a1 1 0 00.93-1.02v-4.31l-4-5.94V22.5l12 4.24v-8.38L25 12V5.24C25 1.87 23.23 0 20 0h-.25zM20 2c2.1 0 3 .95 3 3.24v7.96l12 6.37v4.34l-12-4.24v9.64l4 5.93v2.25l-1-.5-1.28-.66-1.24-.66-2.18-1.17-1.31-.71-2.07 1.17-1.41.78-.94.52-1.1.58-.48.25-.64.33-.35.17v-2.57l4-5.7v-9.55L5 23.92v-4.35l12-6.37V5.25C17 2.95 17.9 2 20 2z" />
    </Styled.PerkIcon>
    <Heading as={Styled.PerkDescription} size="xxs">
      <FormattedMessage id="new_landing_offline_viewing_perk" />
    </Heading>
    <Text
      as={Styled.PerkDescriptionMobile}
      size="xl"
      type="semibold"
      isFixedSize
    >
      <FormattedMessage id="new_landing_offline_viewing_perk" />
    </Text>
  </Styled.Perk>
);

export default OfflineViewing;
